import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      // all these properties will have their type inferred automatically
      product: null,
      variants: null,
      postId: window.getPostId,
      isWarrantySelected: window.productData?.add_warranty_for_product,
      warrantyState: window.productData.add_warranty_for_product
        ? window.productData?.preselect_warranty
        : false,
      showPopover: window.productData?.show_popover,
      warrantyType: window.productData?.select_warranty_type_cc,
      warrantyPriceCalculation: window.productData?.multiply_price_by_amount,
      warrantyTexts: window.productData?.warranty_texts,
      autoSubmitDelay: window.productData?.submit_without_warranty,
      popoverWarranty: false,
      popoverShow: false,
      popoverInteracted: false,
      currencyCode: null,
      campaignId: null,
      paypalEnabled: false,
      paypalMerchant: window.productData?.paypal_merchant,
      nextStep: window.productData?.next_page_on_success,
      enable_3ds_waterfall: window.productData?.enable_3ds_waterfall,
      threeDs_waterfall_campaign_id: window.productData?.['3ds_waterfall_campaign_id'] || '',
      paypalUpsellPrice: window.productData?.paypal_upsell_settings.price,
      initialSet: true
    }
  },
  getters: {
    getColorName() {
      const colors = Object.values(this.variants.color_options)
      let result = colors.map((a) => a.tr_title)

      if (result.every((val, i, arr) => val === arr[0])) {
        return result[0]
      } else {
        return 'Mixed'
      }
    },
    getSizeName() {
      const sizes = Object.values(this.variants.size_options)
      let result = sizes.map((a) => a.sku)

      if (result.every((val, i, arr) => val === arr[0])) {
        return result[0]
      } else {
        return 'Mixed'
      }
    }
  },
  actions: {
    setInitialVariants() {
      const variants = window.productData.variants
      const colors = variants.color_options
      const sizes = variants.size_options
      const qty = parseInt(this.product.amount)

      if (colors.enable_variant_color) {
        const colorsArray = Object.values(colors.colors)
        const default_color = colorsArray.filter((color) => color.default == true)
        if (default_color.length === 0 || default_color.length > 1) {
          console.log(
            '%cVariants: %cEither default color is not set or there are multiple defaults',
            'color:red;font-weight:bold;',
            'color:initial;font-weight:initial;'
          )
        } else {
          this.variants.color_options = Array(qty).fill(default_color[0])
        }
      }

      if (sizes.enable_variant_size) {
        const sizesArray = Object.values(sizes.sizes)
        const default_size = sizesArray.filter((size) => size.default == true)
        if (default_size.length === 0 || default_size.length > 1) {
          console.log(
            '%cVariants: %cEither default size is not set or there are multiple defaults',
            'color:red;font-weight:bold;',
            'color:initial;font-weight:initial;'
          )
        } else {
          this.variants.size_options = Array(qty).fill(default_size[0])
        }
      }
    },
    changeActiveProduct(product, initialSet) {
      this.product = product
      this.initialSet = initialSet
    }
  }
})
